(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/event-by-product-list/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/widgets/event-by-product-list/assets/javascripts/init.js');
"use strict";


setGlobal('svs.widget.event_by_product_list.init', svs.components.sport.eventByProductListWidget.init);

 })(window);